import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { PhotosContainer } from "./ProductPhotos.styled";
import { ProductLabel } from "src/types/graphql.d";
import { ProductPhotoModal } from "./ProductPhotoModal";
import { ImageCarousel } from "./ImageCarousel";
import { ImageGrid } from "./ImageGrid";
import { useImageCarouselDispatch } from "src/hooks/context/use-image-carousel-context";

type ProductPhotosProps = {
  photos: string[];
  labels?: ProductLabel[];
  productName: string;
  productId: string;
};

function ProductPhotos({
  photos,
  labels,
  productName,
  productId,
}: ProductPhotosProps): JSX.Element {
  const ref = useRef<string>("");

  const slicedPhotos = useMemo(() => photos.slice(0, 8) || [], [photos]);
  const slicedLabels = useMemo(() => labels?.slice(0, 2) || [], [labels]);
  const [isZoomOpen, setIsZoomOpen] = useState(false);
  const imageCarouselDispatch = useImageCarouselDispatch();

  const handleImageClick = useCallback(() => {
    setIsZoomOpen(true);
  }, []);

  useEffect(() => {
    if (!ref.current || ref.current !== productId) {
      imageCarouselDispatch({
        type: "SET_SELECTED_IMAGE_INDEX",
        payload: { selectedImageIndex: 0, updateIdentifier: null },
      });
      ref.current = productId;
    }
  }, [productId, imageCarouselDispatch]);

  return (
    <>
      <PhotosContainer>
        <ImageGrid
          photos={slicedPhotos}
          setIsZoomOpen={setIsZoomOpen}
          productName={productName}
          labels={slicedLabels}
        />

        <ImageCarousel
          photos={photos}
          labels={slicedLabels}
          handleImageClick={handleImageClick}
          productName={productName}
        />
      </PhotosContainer>
      <ProductPhotoModal
        photos={photos}
        isZoomOpen={isZoomOpen}
        setIsZoomOpen={setIsZoomOpen}
        productName={productName}
      />
    </>
  );
}

export { ProductPhotos };
